namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class ChangeAltLoginModalWindow extends GContentBase<DetailBase> {
        private data: Gordic.AdmIsl.Interface.GAdmOsobaAlternativniLoginReadDto;
        private ixs_ref: string;
        private servicecnt: GContent;

        private getServiceCnt(): GContent {
            if (this.servicecnt == undefined || this.servicecnt == null)
                this.servicecnt = this.createServiceContent("Gordic.Adm.WebControls.ChangeAltLoginModalWindow")
            return this.servicecnt;
        }

        save() {
            if (this.data.isAzure == true) {
                var typAuth = this.findFields("typ_aut2").gfield("getValue");
                if (typAuth.typ_aut == 10) {
                    var email = this.findFields("login_windows").gfield("getValue");
                    if (/^([\w\.\-]+)@([\w\-]+)((\.(\w){2,3})+)$/.test(email) == false) {
                        this.dialogs.confirm("jres.32000149", "jres:33000256").on("yes", () => { //RC 33000256 : Hodnota v poli email není validní email. Přejete si i přesto pokračovat?
                            this.saveInternal();
                        })
                    } else 
                        this.saveInternal();
                } else
                    this.saveInternal();
            } else 
                this.saveInternal();
        }

        private saveInternal() {
            var novaData: Gordic.AdmIsl.Interface.GAdmOsobaAlternativniLoginSaveDto = {};
            this.hideFlash("error-passwd");
            var form = this.findForms("formAdmOsobaAlternativniLogin");
            form.gform("waitForValues").done(() => {
            if (form.gform("isValid")) {
                return Prefabs.GStringBox.updateChiperPublicKeys(form).then(() => {
                    form.findFields().gfield("model", "collect", novaData);
                    if (novaData.typ_aut2 == 0) {
                        this.getServiceCnt().call("ValidatePassword", { newPassw: novaData.passwd, overenePass: novaData["passwd2"] }).done(() => {
                            this.ulozeni(novaData);
                        }).fail(() => {
                            this.showFlash({
                                id: "overeni-password-err",
                                state: "error",
                                content: "jres:33000252" //RC 33000252 : Zadaná hesla jsou rozdílná.
                            })
                        })
                    }
                    if (novaData.typ_aut2 != 0)
                        this.ulozeni(novaData);
                })
                }
            })
        }

        ulozeni(novadata: any) {
            delete novadata["passwd2"];
            delete novadata["login_virtual"]
            this.getServiceCnt().call("SaveAlternativniLogin", { data: novadata }).done((output) => {
                this.close(true);
            }).fail((ev, obj) => {
                this.showFlash("jres:33000018", "error", "error-passwd"); //RC 33000018 : Chyba při uložení
            })
        }

        onContentReady() {
            this.init();
        }

        private init() {
            DetailBase.DetailBaseInit(this)
            this.loadData();
        }

        private createForm() {
            var _this = this;
            this.MakeForm("formAdmOsobaAlternativniLogin")
            this.MakeField("ixs_ref");
            this.MakeSelectField("typ_aut2", $.extend(Gordic.Prefabs.Select.ginctau(), { serverFilters: { typ_aut: [-10, 0, 10, 30] } }), {
                model: "model.typ_aut2=value.typ_aut",
                change: (ev, obj) => {
                    if (obj) {
                        this.HideField("dat_exp2");
                        this.HideField("login_name_grant2");
                        this.HideField("passwd");
                        this.HideField("passwd2");
                        this.HideField("login_windows");
                        this.HideField("login_azure_ad");
                        this.findFields("passwd").gfield("setValidators", []);
                        this.findFields("passwd2").gfield("setValidators", []);
                        this.findFields("login_azure_ad").gfield("setValidators", []);
                        this.findFields("passwd").gfield("setValue", "");
                        this.findFields("passwd2").gfield("setValue", "");
                        if (!Array.isArray(obj.value)) {
                            if (obj.value) {
                                switch (obj.value.typ_aut) {
                                    case -10:
                                        this.findFields("login_windows").gfield("setValue", "");
                                        this.findFields("login_name_grant2").gfield("setValue", "")
                                        this.findFields("login_azure_ad").gfield("setValue", "")
                                        break;
                                    case 0:
                                        this.ShowField("dat_exp2");
                                        this.ShowField("login_name_grant2");
                                        this.ShowField("passwd");
                                        this.ShowField("passwd2");
                                        this.findFields("login_windows").gfield("setValue", "")
                                        this.findFields("login_azure_ad").gfield("setValue", "")
                                        //this.findFields("passwd").gfield("setValidators", this.createvalidatorsPasswd(false))
                                        //this.findFields("passwd2").gfield("setValidators", this.createvalidatorsPasswd(true))
                                        break;
                                    case 10:
                                        this.ShowField("login_windows");
                                        this.findFields("login_name_grant2").gfield("setValue", "")
                                        this.findFields("login_azure_ad").gfield("setValue", "")
                                        break;
                                    case 30:
                                        this.ShowField("login_azure_ad");
                                        this.findFields("login_name_grant").gfield("setValue", "")
                                        this.findFields("login_windows").gfield("setValue", "")
                                        this.findFields("login_azure_ad").gfield("setValidators", [new Gordic.Validators.Required({ stopping: true })]);
                                        break;
                                }
                            }
                        }
                    }
                }
            })
            this.MakeField("dat_exp2")
            this.MakeField("login_name_grant2")
            this.MakeField("login_azure_ad", {
                model: function (op, dto, opt) {
                    switch (op) {
                        case "apply":
                            if (dto.typ_aut2 == 30)
                                $(this).gfield("setValue", dto.login_name_grant2);
                            break;
                        case "collect": 
                            var current = _this.findFields("typ_aut2").gfield("getValue");
                            if (current)
                                if (current.typ_aut == 30)
                                    dto["login_name_grant2"] = $(this).gfield("getValue");
                            break;
                    }
                }
            })
            if (this.data.isAzure == true) {
                // Pro Azure se zadává mail
                this.DetailForm.addRow("jres:33000255").addField("gstringbox", { //RC 33000255 : Email
                    name: "login_windows",
                    model: function (op, dto, opt) {
                        switch (op) {
                            case "apply":
                                if (dto.typ_aut2 == 10)
                                    $(this).gfield("setValue", dto.login_name_grant2);
                                break;
                            case "collect":
                                var current = _this.findFields("typ_aut2").gfield("getValue");
                                if (current)
                                    if (current.typ_aut == 10) {
                                        var value = $(this).gfield("getValue");
                                        dto["login_name_grant2"] = value;
                                    }
                                break;
                        }
                    }
                })
            } else {
                this.MakeSelectField("login_windows", Gordic.Prefabs.Select.windowsLogins(), {
                    strict: false,
                    dropdown: false,
                    tag: {
                        state: "info",
                        text: "jres:33000254" //RC 33000254 : Login musí být zadán včetně domény např. ORGANIZACE\\uzivatel
                    },
                    invalidTransform: (strValue) => {
                        return { name: strValue }
                    },
                    model: function (op, dto, opt) {
                        switch (op) {
                            case "apply":
                                if (dto.typ_aut2 == 10)
                                    $(this).gfield("setValue", { name: dto.login_name_grant2 });
                                break;
                            case "collect":
                                var current = _this.findFields("typ_aut2").gfield("getValue");
                                if (current)
                                    if (current.typ_aut == 10) {
                                        var value = $(this).gfield("getValue");
                                        if (typeof (value) == "string")
                                            dto["login_name_grant2"] = value;
                                        else
                                            dto["login_name_grant2"] = value.name;
                                    }
                                break;
                        }
                    }
                })
            }
            this.DetailForm.addRow("jres:30028702").addField("gstringbox", Gordic.Prefabs.GStringBox.password({
                    obslouzilJsemSbiraniHodnotZPolicekTakAbyNemohlNastatProblemSNeaktualnimSifrovacimKlicem: true
                }), {
                    name: "passwd"
                })
                .addRow("jres:33000250").addField("gstringbox", Gordic.Prefabs.GStringBox.password({ //RC 33000250 : Ověření hesla
                    obslouzilJsemSbiraniHodnotZPolicekTakAbyNemohlNastatProblemSNeaktualnimSifrovacimKlicem: true
                }), {
                    name: "passwd2"
                })
            this.FinishMakeForm();
            if (this.data.typ_aut2 == 10)
                this.findFields("login_windows").gfield("setValue", { name: this.data.login_name_grant2 })
            else if (this.data.typ_aut2 == 30)
                this.findFields("login_azure_ad").gfield("setValue", { name: this.data.login_name_grant2 })
        } 

        private loadData() {
            var fragments: string[] = [Utils.GAdmIslConst.detail];
            this.isl.AdmOsobaAlternativniLogin.read({ data: { ixs_ref: this.ixs_ref }, fragments: fragments }).getData().done((output) => {
                this.data = output;
                this.MetaData = this.data.MetaData || null;
                this.Permissions = this.data.Permissions || null;
                this.createForm();
                this.element.findFields().gfield("model", "apply", this.data);
                this.SetEditMode(true);
            })
        }

        private createvalidatorsPasswd(isPasswd2: boolean): Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions>[] {
            var validators: Gordic.Validators.Validator<Gordic.Validators.ValidatorOptions>[] = [];
            if (isPasswd2 == true) {
                var valSamePasswd = new Gordic.Validators.Base({ message: "jres:33000019" }) //RC 33000019 : Hesla jsou rozdílná!
                valSamePasswd.validate = (value, source) => {
                    var form = this.findForms("formAdmOsobaAlternativniLogin")
                    var passwd1 = form.findFields("passwd").gfield("getValue")
                    var passwd2 = form.findFields("passwd2").gfield("getValue")
                    if (passwd1 != passwd2)
                        return false
                    else
                        return true
                }
                validators.push(valSamePasswd);
            }
            validators.push(new Gordic.Validators.Required);
            return validators;
        }
    }
}